import React from 'react';
import styled, { css } from 'styled-components';
import { vars } from '../../theme';
import { TSize } from '../../tokens/types';

export enum BadgeType {
    Error = 'error'
}

const SIZES: Record<TSize, string> = {
    sm: '16px',
    // TODO: get real sizes
    md: '24px',
    lg: '32px',
    // XL TSize was needed, this is temporal.
    xl: '32px'
};

// TODO: get all possible types/ colors
const COLORS: Record<BadgeType, string> = {
    [BadgeType.Error]: vars.colors.base.danger
};

export interface Props {
    /** Badge color and style. Currently only `BadgeType.Error` (red dot) is supported. */
    type: BadgeType;
    /** Diameter of the dot. Defaults to `'sm'` (16px) when omitted. */
    size?: TSize;
    /** When true, scales the badge into view with a CSS transition. When false or omitted, the badge is hidden (scale 0). */
    visible?: boolean;
}

const HBBadge = (props: Props) => {
    return <Badge {...props} />;
};

export default HBBadge;

const Badge = styled.div<Props>`
    width: ${props => SIZES[props.size || 'sm']};
    height: ${props => SIZES[props.size || 'sm']};
    border-radius: ${props => SIZES[props.size || 'sm']};
    border: solid 3px ${vars.colors.surface.container};
    background-color: ${props => COLORS[props.type]};
    transform: scale(0) translate(50%, -50%);

    ${({ visible }) =>
        visible &&
        css`
            transform: scale(1) translate(50%, -50%);
        `}

    transition: transform 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    /* TODO: dynamic positioning */
    position: absolute;
    top: 0;
    right: 0;
`;
